// ── Les libelles du support : poids, durees, navigateur ──

/** « 840 Ko », « 1,2 Mo » */
export function formatBytes(bytes: number): string {
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024)).toLocaleString('fr-FR')} Ko`;
  return `${(bytes / (1024 * 1024)).toLocaleString('fr-FR', { maximumFractionDigits: 1 })} Mo`;
}

/** « Chrome 141 · Windows », d'apres l'agent du navigateur */
export function describeBrowser(ua: string): string {
  const browser =
    /Edg\/(\d+)/.exec(ua) ? `Edge ${/Edg\/(\d+)/.exec(ua)![1]}` :
    /Firefox\/(\d+)/.exec(ua) ? `Firefox ${/Firefox\/(\d+)/.exec(ua)![1]}` :
    /Chrome\/(\d+)/.exec(ua) ? `Chrome ${/Chrome\/(\d+)/.exec(ua)![1]}` :
    /Version\/(\d+).*Safari/.exec(ua) ? `Safari ${/Version\/(\d+)/.exec(ua)![1]}` : 'Navigateur inconnu';
  const os =
    /Windows/.test(ua) ? 'Windows' : /Android/.test(ua) ? 'Android' : /iPhone|iPad/.test(ua) ? 'iOS' :
    /Mac OS X/.test(ua) ? 'macOS' : /Linux/.test(ua) ? 'Linux' : '';
  return os ? `${browser} · ${os}` : browser;
}

export const VIEW_LABELS = { '2d': '2D', '3d': '3D', visit: 'Visite', section: 'Coupe' } as const;

export const STATUS_LABELS = { NEW: 'Nouveau', IN_PROGRESS: 'En cours', ANSWERED: 'Répondu', RESOLVED: 'Résolu' } as const;
export const STATUS_TONES = {
  NEW: 'bg-blue-50 text-blue-700 border-blue-200',
  IN_PROGRESS: 'bg-amber-50 text-amber-800 border-amber-200',
  ANSWERED: 'bg-green-50 text-green-700 border-green-200',
  RESOLVED: 'bg-slate-100 text-slate-600 border-slate-200',
} as const;
export const KIND_LABELS = { BUG: 'Problème', QUESTION: 'Question', IDEA: 'Idée' } as const;

/** « 01/11/2026 14:32 », a l'heure de Paris */
export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
/** « 01/11/2026 » et « 14:32 », a l'heure de Paris (le mail) */
export const formatDay = (d: Date) => d.toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', year: 'numeric' });
export const formatHour = (d: Date) => d.toLocaleTimeString('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit' });
export const formatTime = (iso: string) =>
  new Date(iso).toLocaleTimeString('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', second: '2-digit' });
